export const phoneNumberRegex = /^\+\d+$/;
export const screenSizes = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1440,
};

export type ScreenSize = keyof typeof screenSizes;

export const mainSectionsPaddings = "py-10 lg:py-24";
export const sectionPaddings = "py-20 lg:py-40";

export const newsletterAgreementLink =
  "https://upacjenta.pl/wp-content/uploads/2024/01/20230609_House-Med_Regulamin-Newsletter.docx.pdf";

// export const hsApiUrl = "https://api.hsforms.com/submissions/v3/integration/secure/submit/";
export const hsApiUrl = "https://api.hsforms.com/submissions/v3/integration/submit/";

export const isBrowser = typeof window !== "undefined";
